import React from 'react';
import ReactSideSheet from 'react-side-sheet';
import * as S from './SideSheet.styles';
import { styleSideSheetConfig } from './SideSheetConfig.inner';
import Icon from '../Icon/Icon';

import PropTypes from 'prop-types';
import theme from '../../assets/styles/theme';
import H from '../Texts/H/H';
import Span from '../Texts/Span/Span';

export const SideSheet = ({
  children,
  isOpen,
  onDismiss,
  onClose,
  title,
  subtitle,
  footer,
  size,
  previousStepAction,
  variant,
  overlayBackground = 'none',
}) => {
  const sideSheetSizes = {
    sm: 360,
  };

  const isOverlayBackground = {
    none: 'none',
    default: '',
  };

  const sideSheetVariants = {
    icon: {
      variant: variant === 'default' ? 'neutral' : variant,
      modifier: variant === 'neutral' ? 'strong' : 'regular',
    },
    subtitle: variant === 'default' ? 'neutral' : variant,
    title: {
      variant: variant === 'default' ? 'neutral' : variant,
      modifier: variant === 'default' ? 'strong' : 'regular',
    },
    header: {
      variant: variant === 'default' ? 'neutral' : variant,
      modifier: variant === 'neutral' ? 'strong' : 'weak',
    },
  };
  return (
    <ReactSideSheet
      isOpen={isOpen}
      styles={styleSideSheetConfig({
        width: sideSheetSizes[size],
        background: theme.colors.neutral.bg.weak,
        boxShadow: theme.elevations['elevation-3'],
        overlayBackround: isOverlayBackground[overlayBackground],
      })}
      onDismiss={onDismiss}
    >
      <S.Content data-testid={'sidesheet-content'} size={size}>
        <S.Header
          hasPreviousStep={previousStepAction}
          data-testid={'sidesheet-header'}
          colors={sideSheetVariants.header}
        >
          {previousStepAction && (
            <S.PreviousIconWrapper>
              <Icon
                name='arrow_left_outline'
                onClick={previousStepAction}
                width={24}
                height={24}
                variant={sideSheetVariants.icon.variant}
                modifier={sideSheetVariants.icon.modifier}
                cursor='pointer'
              />
            </S.PreviousIconWrapper>
          )}
          <S.HeaderWrapper hasPreviousStep={previousStepAction}>
            <S.TitleWrapper>
              <H
                type='4'
                variant={sideSheetVariants.title.variant}
                modifier={sideSheetVariants.title.modifier}
                weight='bold'
              >
                {title}
              </H>
              <S.CloseIconWrapper>
                <Icon
                  name='cancel_outline'
                  onClick={onClose ? onClose : onDismiss}
                  width={24}
                  height={24}
                  variant={sideSheetVariants.icon.variant}
                  modifier={sideSheetVariants.icon.modifier}
                  cursor='pointer'
                />
              </S.CloseIconWrapper>
            </S.TitleWrapper>
            {subtitle && (
              <S.SubTitleWrapper>
                <Span
                  type='2'
                  variant={sideSheetVariants.subtitle}
                  modifier='regular'
                >
                  {subtitle}
                </Span>
              </S.SubTitleWrapper>
            )}
          </S.HeaderWrapper>
        </S.Header>
        <S.Body>{children}</S.Body>
        {footer && <S.Footer>{footer}</S.Footer>}
      </S.Content>
    </ReactSideSheet>
  );
};

SideSheet.defaultProps = {
  isOpen: false,
  closeOnApply: true,
  size: 'sm',
  variant: 'default',
};

SideSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  variant: PropTypes.oneOf([
    'danger',
    'success',
    'info',
    'default',
    'warning',
    'neutral',
  ]),
};

export default SideSheet;
